import { roles } from 'auth/roles'
import { useSelector } from 'react-redux'
import { userCompaniesSelector } from 'services/auth/slice'
import { FeatureFlags } from 'utils/constants'

export function useUserHasFeature(feature) {
  const userCompanies = useSelector(userCompaniesSelector)
  if (!userCompanies || userCompanies.length === 0) return false
  const userRoles = userCompanies.find(u => u.companyId === +localStorage.getItem('companyId'))?.roles || {}

  if (feature === FeatureFlags.VatRecordingGUI) {
    return userRoles?.includes('VatRecording')
  }
  if (feature === FeatureFlags.VatDeductionGUI) {
    return userRoles?.includes('VatDeduction')
  }
  if (feature === FeatureFlags.EDespatchAdvices) {
    return userRoles?.includes(roles.DESPATCH_ADVICES_OUTGOING) || userRoles?.includes(roles.DESPATCH_ADVICES_INCOMING)
  }
  if (feature === FeatureFlags.CrossBorderTransactions) {
    return userRoles?.includes(roles.CROSS_BORDER_TRANSACTIONS)
  }

  return feature === FeatureFlags.Audit
}
